import React, { useContext, useEffect } from 'react';
import {
  SearchBox,
  SkipToContent,
  SkipToContentItem,
} from '@monash/portal-react';
import c from './searchbar.module.scss';
import { getIcon } from '@monash/portal-frontend-common';
import { getPrimaryUrl } from '../search-result-entity/adapters/utils';
import { SearchContextHoneycomb } from '@/components/providers/search-provider-honeycomb/SearchProviderHoneycomb';

const SearchBar = ({
  hasClearButton,
  hasCloseButton,
  hasSkipToContent,
  onClose,
}) => {
  const {
    searchTarget,
    setSearchTarget,
    searchResult,
    runSearch,
    runSearchSuggestions,
    searchSuggestionsResult,
  } = useContext(SearchContextHoneycomb);

  useEffect(() => {
    runSearchSuggestions(searchTarget.trim());
  }, [runSearchSuggestions, searchTarget]);

  const quickLinks = searchSuggestionsResult?.quickLinks?.map((link) => ({
    ...link,
    icon: link.app ? getIcon(link.app, 20) : getIcon(link.icon, 20),
  }));

  const links = searchSuggestionsResult?.links?.map((link) => ({
    ...link,
    url: getPrimaryUrl(link),
    icon: link.app ? getIcon(link.app, 20) : getIcon(link.icon, 20),
  }));

  return (
    <div>
      <div className={c.resultSearchBar}>
        <div className={c.searchBar}>
          <SearchBox
            searchString={searchTarget}
            onInput={setSearchTarget}
            onSearch={runSearch}
            onClose={onClose}
            placeholder="Explore services, experiences and links"
            quickLinks={quickLinks}
            historySearches={searchSuggestionsResult?.searchHistory}
            links={links}
            searchResult={searchResult}
            hasClearButton={hasClearButton}
            hasCloseButton={hasCloseButton}
          />
        </div>
      </div>
      {hasSkipToContent && (
        <SkipToContent id="skipToContentSearch" search={true}>
          <SkipToContentItem
            text="Search Result"
            skipTo="#searchResultContainer [data-search-result-item]"
            targetTabIndex={null}
            onClose={onClose}
          />
        </SkipToContent>
      )}
    </div>
  );
};

export default SearchBar;
